import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import React, { useEffect, useState } from "react";
import { QueryParams } from "../../../models/user";

const useStyles = makeStyles((theme) => ({
  actions: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
  },
}));

export default function Filter({
  onFilter,
  params,
  className,
}: {
  onFilter: (params: QueryParams) => void;
  params: QueryParams;
  className?: string;
}) {
  const classes = useStyles();

  const [uid, setUID] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [name, setName] = useState<string>("");
  const [nickname, setNickname] = useState<string>("");
  const [hasSubscription, setHasSubscription] = useState<string>("");
  const [hasOneTimePurchase, setHasOneTimePurchase] = useState<string>("");

  useEffect(() => {
    setUID(params.uid || "");
    setEmail(params.email || "");
    setName(params.name || "");
    setNickname(params.nickname || "");
    setHasSubscription(
      typeof params.hasSubscription === "boolean"
        ? params.hasSubscription.toString()
        : ""
    );
    setHasOneTimePurchase(
      typeof params.hasOneTimePurchase === "boolean"
        ? params.hasOneTimePurchase.toString()
        : ""
    );
  }, [params]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onFilter({
      uid: uid || undefined,
      email: email || undefined,
      name: name || undefined,
      nickname: nickname || undefined,
      hasSubscription:
        hasSubscription === ""
          ? undefined
          : hasSubscription === "true",
      hasOneTimePurchase:
        hasOneTimePurchase === ""
          ? undefined
          : hasOneTimePurchase === "true",
    });
  };

  const handleReset = () => {
    onFilter({});
  };

  return (
    <Card className={className}>
      <CardContent>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} sm={6} md={2}>
              <TextField
                label="UID"
                variant="outlined"
                fullWidth
                size="small"
                value={uid}
                onChange={(e) => setUID(e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={2}>
              <TextField
                label="メールアドレス"
                variant="outlined"
                fullWidth
                size="small"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={2}>
              <TextField
                label="氏名"
                variant="outlined"
                fullWidth
                size="small"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={2}>
              <TextField
                label="ニックネーム"
                variant="outlined"
                fullWidth
                size="small"
                value={nickname}
                onChange={(e) => setNickname(e.target.value)}
              />
            </Grid>
            <Grid item xs={6} sm={4} md={1}>
              <TextField
                label="サブスク"
                variant="outlined"
                fullWidth
                size="small"
                select
                SelectProps={{ native: true }}
                InputLabelProps={{ shrink: true }}
                value={hasSubscription}
                onChange={(e) => setHasSubscription(e.target.value)}
              >
                <option value="">全て</option>
                <option value="true">あり</option>
                <option value="false">なし</option>
              </TextField>
            </Grid>
            <Grid item xs={6} sm={4} md={1}>
              <TextField
                label="買い切り"
                variant="outlined"
                fullWidth
                size="small"
                select
                SelectProps={{ native: true }}
                InputLabelProps={{ shrink: true }}
                value={hasOneTimePurchase}
                onChange={(e) => setHasOneTimePurchase(e.target.value)}
              >
                <option value="">全て</option>
                <option value="true">あり</option>
                <option value="false">なし</option>
              </TextField>
            </Grid>
            <Grid item xs={12} sm={4} md={2}>
              <div className={classes.actions}>
                <Button
                  color="primary"
                  type="submit"
                  variant="contained"
                  size="small"
                >
                  絞り込む
                </Button>
                <Button
                  color="default"
                  variant="outlined"
                  size="small"
                  onClick={handleReset}
                >
                  リセット
                </Button>
              </div>
            </Grid>
          </Grid>
        </form>
      </CardContent>
    </Card>
  );
}
